/**
 * S3 object key segment for partner uploads (listing prefix only).
 * Must stay aligned with server **AWS_S3_PARTNER_PREFIX** — production uses **`partners`**
 * (legacy buckets may use `partner-onboarding`; keys stored in DB/API must match server config).
 *
 * Full object keys (`partners/{userId}/…`) normally come from the API after presign-upload;
 * the client only builds **list** prefixes here.
 */
export const PARTNER_S3_PREFIX = 'partners';

/** Prefix for listing one partner's objects: `partners/{userId}/` */
export function partnerListPrefix(userId) {
  const id = userId != null ? String(userId).trim() : '';
  if (!id) return `${PARTNER_S3_PREFIX}/`;
  return `${PARTNER_S3_PREFIX}/${id}/`;
}
